<template>
  <v-sheet class="pa-3 f-16 d-flex border-md">
    <div
      v-if="icon"
      class="align-self-center mr-3"
    >
      <v-icon class="i sz-red--text">
        {{ icon }}
      </v-icon>
    </div>
    <div>
      <h4
        v-if="title"
        class="sz-red--text font-weight-bold"
        :class="{ 'd-inline': inline }"
      >
        {{ title }}
      </h4>
      <p
        v-if="text"
        v-orphans
        class="sz-primary-grey--text font-weight-regular"
        :class="{ 'd-inline': inline }"
        v-html="text"
      />
      <div
        v-if="slots.default"
        v-orphans
        class="sz-primary-grey--text font-weight-regular"
        :class="{ 'd-inline': inline }"
      >
        <slot />
      </div>
    </div>
  </v-sheet>
</template>

<script setup lang="ts">
import { useSlots } from 'vue';

type Props = {
  title?: string;
  text?: string;
  icon?: string;
  inline?: boolean;
}

withDefaults(defineProps<Props>(), {
    icon: '$bellOutline',
    subtitle: ''
});

const slots = useSlots();
</script>

<style lang="scss">
.location-info-box {
  border: 2px solid #D9D9D9;
  padding: 16px;
  display: grid;
  grid-template-columns: auto 1fr;
  grid-template-areas:
    "icon title"
    "icon subtitle";

  &__icon {
    grid-area: icon;
    align-self: center;
    padding: 16px;
  }

  &__title {
    grid-area: title;

    &--inline {
      display: inline;
    }
  }

  &__subtitle {
    grid-area: subtitle;

    &--inline {
      display: inline;
    }
  }
}
</style>
